<ng-container *ngIf="list.length > 0; else emptyTicketsTpl">
  <article
    class="incidencias-board-card is-clickable ticket-admin-card"
    *ngFor="let item of list; trackBy: trackByTicketId"
    (click)="cargarDatosTicket(item)"
    (keydown.enter)="cargarDatosTicket(item)"
    [style.--ticket-column-color]="columnColor || '#247fd5'"
    [class.ticket-admin-card--updated]="item.actualizado">
    <header class="ticket-admin-card__header">
      <div class="ticket-admin-card__headline">
        <span class="ticket-admin-card__ticket">
        #{{ item.id_ticket }}
      </span>

        <strong
          class="ticket-admin-card__title"
          matTooltip="{{ item.asunto }}"
          [matTooltipPosition]="'above'">
          {{ item.asunto }}
        </strong>
      </div>

      <span
        class="ticket-admin-card__date"
        matTooltip="{{ getCardDateLabel(item) }}"
        [matTooltipPosition]="'above'">
        <mat-icon>calendar_today</mat-icon>
        <span class="ticket-admin-card__date-content">
          <span class="ticket-admin-card__date-line">{{ getCardDateDayLabel(item) }}</span>
          <span class="ticket-admin-card__date-line ticket-admin-card__date-line--time">
            {{ getCardDateTimeLabel(item) }}
          </span>
        </span>
      </span>
    </header>

    <div class="ticket-admin-card__badges">
      <span
        *ngIf="item.aTiempo && item.id_estatus !== 4 && item.id_estatus !== 5"
        class="ticket-admin-card__badge ticket-admin-card__badge--sla"
        [ngStyle]="{ 'background-color': item.color || '#475569' }">
        {{ item.tiemp }}
      </span>

      <span
        class="ticket-admin-card__badge"
        [ngClass]="getPriorityClass(item.prioridad)">
        {{ item.prioridad || 'Sin prioridad' }}
      </span>

      <span
        class="ticket-admin-card__badge ticket-admin-card__badge--area"
        *ngIf="getCardCategoryLabel(item)">
        {{ getCardCategoryLabel(item) }}
      </span>

      <span
        class="ticket-admin-card__badge ticket-admin-card__badge--status"
        *ngIf="getStatusChipLabel(item)">
        {{ getStatusChipLabel(item) }}
      </span>
    </div>

    <footer class="ticket-admin-card__footer">
      <span
        class="ticket-admin-card__meta ticket-admin-card__meta--area"
        *ngIf="getCardFooterAreaLabel(item)"
        matTooltip="{{ getCardFooterAreaLabel(item) }}"
        [matTooltipPosition]="'above'">
        {{ getCardFooterAreaLabel(item) }}
      </span>

      <span class="ticket-admin-card__meta ticket-admin-card__meta--user">
        <mat-icon>person_outline</mat-icon>
        <strong>{{ item.nombreSolicitante || 'Sin solicitante' }}</strong>
      </span>
    </footer>
  </article>
</ng-container>

<ng-template #emptyTicketsTpl>
  <div class="table-page__empty-state incidencias-board-page__empty-column ticket-admin-card__empty">
    <mat-icon>inbox</mat-icon>
    <p>Sin tickets en {{ columnTitle || 'este estatus' }}.</p>
  </div>
</ng-template>
